import React from "react";
import ReactDOM from "react-dom";

const IntentConfirmationPopup = ({ confirmationData, onConfirm }) => {
  if (!confirmationData || !confirmationData.needs_confirmation) {
    return null;
  }

  const { message, options = [], detected_language } = confirmationData;

  const getYesNoLabels = (lang) => {
    switch(lang) {
      case "sinhala":
        return { yes: "ඔව්", no: "නැත" };
      case "tamil":
        return { yes: "ஆம்", no: "இல்லை" };
      default:
        return { yes: "Yes", no: "No" };
    }
  };

  const labels = getYesNoLabels(detected_language || "english");

  const popup = (
    <div className="intent-popup-overlay">
      <div className="intent-popup-container">

        <h2 className="intent-popup-question">
          {message || "Do you want leave balance?"}
        </h2>

        <div className="intent-popup-buttons">
          <button
            onClick={() => onConfirm("leave_balance")}
            className="intent-popup-btn intent-popup-btn-yes"
          >
            {labels.yes}
          </button>

          <button
            onClick={() => onConfirm("document_search")}
            className="intent-popup-btn intent-popup-btn-no"
          >
            {labels.no}
          </button>
        </div>

      </div>
    </div>
  );

  return ReactDOM.createPortal(popup, document.body);
};

export default IntentConfirmationPopup;
